import { Skeleton } from '@/shared/ui/Skeleton'

import styles from './styles.module.scss'

/**
 * Posição dinâmica da barra enquanto o destino real é desconhecido. Ocupa a
 * mesma caixa do item real para que a chegada dos itens não altere a altura.
 *
 * Deliberadamente NÃO é um `button` nem um `Link`: no estado de não-saber não
 * pode existir alvo de toque navegável, porque o destino seria o errado.
 */
export const BottomNavItemSkeleton = () => (
  <span className={styles.BottomNavItemSkeleton}>
    <span className={styles.BottomNavItemInner}>
      <span className={styles.BottomNavItemIconBox}>
        <Skeleton className="h-[30px] w-[30px]" variant="circle" />
      </span>
      <Skeleton className="mt-[1px] h-[10px] w-[38px]" variant="pill" />
    </span>
  </span>
)
